module.exports = __webpack_public_path__ + "static/media/Fourth-People2.1501b789.png";